// extracted by mini-css-extract-plugin
export var email = "footer-module--email--DcNaS";
export var brakeline = "footer-module--brakeline--7Lpzf";
export var trademark = "footer-module--trademark--f8lcR";
export var footer = "footer-module--footer--lU7l1";
export var topfooter = "footer-module--topfooter--6yLxM";
export var contact = "footer-module--contact--KtqP4";